//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { useSelector } from 'react-redux';
//@end

//@import components
import NewsModule from 'app_components/modules/campus/news'
import SchedulingExtendModule from 'app_components/modules/schedulingExtend'
import CertificationsModule from 'app_components/modules/certifications'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../companyDashboardHomeModule.scss'
import RelatedCoursesModule from 'app_components/modules/campus/academic/relatedCourses';
import { CombinedReducers } from 'app_events/index';

// @ADD Component types
interface ICompanyDashboardHomeModuleLayoutProps {}

const CompanyDashboardHomeModuleLayout: React.FC<ICompanyDashboardHomeModuleLayoutProps> = (props) => {

  const auth = useSelector((state: any) => state.auth ? state.auth : null)
  const userId = useSelector((state: CombinedReducers) => state.auth?.user?.data?.id)
  const adminCompany = useSelector((state: CombinedReducers) => state.auth?.user?.data?.admin_company)

  const { t } = useTranslation()

  const [menuSelected, setMenuSelected] = useState('1');
  const menus = [
    { name: t('modules.company_dashboard.sections.scheduling'), value: '1', status: 'enabled' },
    { name: t('modules.company_dashboard.sections.certifications'), value: '2', status: 'enabled' },
  ];

  return(
    <div className='company_dashboard-component'>
      {auth?.user?.data?.company?.logo && (
        <section className='company-dashboard-section-info'>
          <img src={auth?.user?.data?.company?.logo} alt="" />
        </section>
      )}
      <section className="company-dashboard-section-news" id="company_dashboard_section_news">
        {/* <NewsModule category='company' /> */}
        <RelatedCoursesModule
          content='slider'
          title='CURSOS RECOMENDADOS'
          initialNumberCarousel={3}
          hideFooterText
        />
      </section>
      <section className="company-dashboard-main">
        <div className="row">
          <div className="col-12">
            <div className="company-sections">
              <ButtonGroup toggle>
                {menus.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    type="radio"
                    variant="secondary"
                    name="radio"
                    value={radio.value}
                    checked={menuSelected === radio.value}
                    onChange={(e) => setMenuSelected(e.currentTarget.value)}
                    disabled={radio.status === 'disabled'}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </div>

            {menuSelected === '1' && (<SchedulingExtendModule contact={adminCompany ? undefined : userId} company={auth?.user?.data?.company}/>)}
            {menuSelected === '2' && (<CertificationsModule company={auth?.user?.data?.company}/>)}
          </div>
        </div>
      </section>
    </div>
  )
}

export default CompanyDashboardHomeModuleLayout
